import { Map, Record, Set } from 'immutable';
import { SET_BETS as OPEN_SET_BETS } from '../../containers/openBets/actions';
import { SET_BETS as SETTLED_SET_BETS } from '../../containers/settledBets/actions';
import { LOG_IN, LOG_OUT } from '../user/actions';
import { DISABLE_ADD, VIEW_ENTER } from './actions';

export const InitialState = new Record({
  addDisabled: false,
  entities: new Map()
});

const Slip = new Record({
  slipId: '',
  slipTotalStake: '0.00',
  slipTotalPayout: '0.00',
  slipStatus: '',
  bets: new Set()
});

const mapSlips = bet => new Slip({
  slipId: bet.slipId,
  slipTotalStake: bet.slipTotalStake,
  slipTotalPayout: bet.slipTotalPayout,
  slipStatus: bet.slipStatus,
  bets: new Set([bet.betId])
});

const reduceSlips = (slips, slip) => (
  slips.update(slip.slipId, s => slip.update('bets', b => (s ? b.union(s.bets) : b)))
);

export default (state = new InitialState(), action) => {
  switch (action.type) {
    case VIEW_ENTER: {
      return state.set('addDisabled', false);
    }
    case DISABLE_ADD: {
      return state.set('addDisabled', true);
    }
    case LOG_IN:
    case LOG_OUT: {
      return new InitialState();
    }
    case OPEN_SET_BETS:
    case SETTLED_SET_BETS: {
      const { results: { bets }, incremental, incrementalByDate, incrementalBySlip } = action;
      const slips = bets.map(mapSlips).reduce(reduceSlips, new Map());

      if (incremental || incrementalByDate || incrementalBySlip) {
        return state.mergeDeep({ entities: slips });
      }
      return state.set('entities', slips);
    }
    default: {
      return state;
    }
  }
};
